import { Col, Row, Table } from "react-bootstrap";
import { isSuperAdmin } from "../../../Services/common";
import { getColorFromStatus } from "../../../Utils/appUtils";
import * as stringUtils from "../../../Utils/stringUtils";
import IconResource from "../../../Wrapper/IconResource/IconResource";
import ImageResource from "../../../Wrapper/ImageResource/ImageResource";
import Button from "../../_widgets/Button/Button";
import DateRangePicker from "../../_widgets/DateRangePicker/DateRangePicker";
import Input from "../../_widgets/Input/Input";
import MainLoader from "../../_widgets/Loader/MainLoader";
import ModalImport from "../../_widgets/Modal/ModalImport";
import NavBar from "../../_widgets/NavBar/NavBar";
import CustomPagination from "../../_widgets/Pagination/Pagination";
import Text from "../../_widgets/Text/Text";
import CustomTooltip from "../../_widgets/Tooltip/CustomTooltip";
import AnimatedPage from "../../AnimatedPage/AnimatedPage";
import EditDiagnosisModal from "./DiagnosisTypeModal";

const DiagnosisTypesUI = ({
  modalShow,
  importListing,
  exportList,
  importModal,
  importList,
  setSelectedRows,
  setImportModal,
  openImportModal,
  setModalShow,
  statusHandler,
  handleClose,
  diagnosisList,
  addDiagnosisData,
  setAddDiagnosisData,
  addDiagnosis,
  editDiagnosis,
  onPageChange,
  dates,
  setDates,
  datePickerStartRef,
  datePickerEndRef,
  searchQuery,
  setSearchQuery,
  loading,
  buttonLoading,
  Action,
  getDiagnosisList,
  selectedRows,
}) => {
  return (
    <AnimatedPage>
      <NavBar
        button="Add Diagnosis"
        buttonIcon="diagnosis"
        button2={!isSuperAdmin() && "Import Diagnosis Types"}
        buttonIcon2="download"
        button2onclick={openImportModal}
        heading="Diagnosis"
        onClick={() => {
          document.body.classList.toggle("side_active");
          document.body.classList.toggle("side_active_mb");
        }}
        setModalShow={setModalShow}
        Icon="menu"
        buttons_responsive={true}
      />

      <ModalImport
        show={importModal}
        handleClose={() => setImportModal(false)}
        buttonLoading={buttonLoading}
        handleSaveClick={exportList}
        loading={loading}
        name="Diagnosis"
        data={importList}
        importListing={importListing}
        selectedRows={selectedRows}
        setSelectedRows={setSelectedRows}
      />

      <EditDiagnosisModal
        modalShow={modalShow}
        setModalShow={setModalShow}
        handleClose={handleClose}
        addDiagnosisData={addDiagnosisData}
        addDiagnosis={addDiagnosis}
        editDiagnosis={editDiagnosis}
        buttonLoading={buttonLoading}
        setAddDiagnosisData={setAddDiagnosisData}
      />

      <div className="patient_list white_card">
        <div className="top_bar">
          <Text type="h2" text="" />
          <Row className="search_filter">
            <Col lg={4}>
              <div>
                <Input
                  placeholder="Search"
                  id="searchInput"
                  suffixIcon="search"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  onClickIconSuff={() => getDiagnosisList()}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      getDiagnosisList();
                    }
                  }}
                  iconTooltip="Search"
                />
              </div>
            </Col>
            <Col lg={8}>
              <div className="date_range_picker">
                <DateRangePicker
                  startDate={dates?.startDate}
                  setStartDate={(startDate) => setDates({ ...dates, startDate })}
                  endDate={dates?.endDate}
                  setEndDate={(endDate) => setDates({ ...dates, endDate })}
                  onChange={(startDate, endDate) => setDates({ startDate, endDate })}
                  datePickerStartRef={datePickerStartRef}
                  datePickerEndRef={datePickerEndRef}
                  showDateShortcuts={true}
                />
              </div>
            </Col>
          </Row>
        </div>

        <div className="custom_table position-relative">
          {loading ? (
            <MainLoader />
          ) : diagnosisList.data?.length > 0 ? (
            <>
              <div>
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th style={{ width: "25%" }}>Name</th>
                      <th style={{ width: "40%" }}>Description</th>
                      <th style={{ width: "10%" }}>Status</th>
                      <th style={{ width: "25%" }}>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {diagnosisList?.data?.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td className="word-break">
                            <CustomTooltip text={data.name} placement={"top"}>
                              {data.name}
                            </CustomTooltip>
                          </td>

                          <td className="word-break">
                            <CustomTooltip text={data.description} placement="top">
                              {data.description ? stringUtils.slice(data.description, 100) : "-"}
                            </CustomTooltip>
                          </td>
                          <td>
                            <CustomTooltip
                              type="popover"
                              button={
                                <div className="p-1">
                                  <Button
                                    isLoading={buttonLoading}
                                    onClick={() => statusHandler(data)}
                                    buttonType="primary"
                                    text={data.status === "ACTIVE" ? "Deactivate" : "Activate"}
                                  />
                                </div>
                              }
                              placement="top"
                            >
                              <div className={`status status__${getColorFromStatus(data.status)}`}>
                                <Text text={stringUtils.capitalizeFirstLetter(data.status)} />
                              </div>
                            </CustomTooltip>
                          </td>

                          <td>
                            <div className="d-flex align-items-center gap-2 justify-content-center">
                              <CustomTooltip text="Edit" placement={"top"}>
                                <Button
                                  className="p-1 bg-transparent border-0"
                                  icon={<IconResource type="edit" color="var(--light-text)" />}
                                  onClick={() => Action(data, "edit")}
                                />
                              </CustomTooltip>
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <CustomPagination
                activePage={diagnosisList?.current_page}
                onPageChange={onPageChange}
                pageLength={diagnosisList?.per_page}
                totalData={diagnosisList?.total}
                lastPage={diagnosisList?.last_page}
              />
            </>
          ) : (
            <>
              <div className="no_data position-relative">
                <ImageResource type="noData" style={{ width: "300px" }} className="img-fluid" />
                <Text type="h2" text="There is no data to display. Try re-setting filters!" />
                <Button
                  buttonType="primary"
                  text="Add Diagnosis"
                  suffixIcon={<IconResource type="diagnosis" />}
                  onClick={() => setModalShow(true)}
                />
              </div>
            </>
          )}
        </div>
      </div>
    </AnimatedPage>
  );
};

export default DiagnosisTypesUI;
